import React, { useEffect, useState } from "react";
import { PiGreaterThan } from "react-icons/pi";
import { RiResetLeftFill } from "react-icons/ri";
import DynamicTable from "../../../Extra/DynamicTable";

const LTTrainWiseSummary = ({ data }) => {
  const FYs = [...new Set(data.map((o) => o.F_YEAR))];
  const [activeFY, setActiveFY] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  const remarkTableHeader = {
    F_YEAR: "F YEAR",
    detention_grp: "Detention Group",
    group_code: "Group Code",
    sub_group_code: "Sub Group Code",
    trainNo: "Train No",
    detTime: "Det Time",
    section: "Section",
    remark: "Remark",
  };
  const [filters, setFilters] = useState({
    F_YEAR: null,
    trainNo: null,
  });
  const [filteredData, setFilteredData] = useState([]);
  function filterData() {
    return data?.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (value) {
          return item[key] === value;
        } else {
          return true;
        }
      });
    });
  }
  useEffect(() => {
    // if (Object.keys(filters).length > 0) {
    setFilteredData(filterData((data, filters)));
    // } else {
    //   setFilteredData(data);
    // }
  }, [filters, data]);

  const getCountMap = (arr, key) =>
    arr.reduce((acc, curr) => {
      const value = curr[key];
      if (!value) return acc;
      acc[value] = (acc[value] || 0) + 1;
      return acc;
    }, {});

  const TwoRowTable = ({ title, label, dataMap, type, F_YEAR }) => (
    <div className="col-md-4 mb-4" style={{ width: "300px" }}>
      <div
        className="card shadow-sm rounded-4"
        style={{ background: "rgba(0,0,0,0)" }}
      >
        <div className="card-header text-center fw-bold">{title}</div>

        <div
          className="card-body p-2 table-responsive newUiBody"
          style={{ height: "420px" }}
        >
          <table className="table newUiTable table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>{label}</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(dataMap)
                .sort(([, a], [, b]) => b - a)
                .map(([key, count]) => (
                  <tr
                    key={key}
                    //  className={`text-center border bo${activeRow === key ? "active-row" : ""}`}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        activeRow === key ? "#87CEEB" : "transparent",
                      fontWeight: activeRow === key ? "600" : "normal",
                    }}
                    onClick={() => {
                      if (type != "trainNo") return;

                      setActiveRow(key); // 👈 mark clicked row
                      setFilters((prev) => ({
                        ...prev,
                        [type]: key,
                        F_YEAR: F_YEAR,
                      }));
                    }}
                  >
                    <td>{key}</td>
                    <td>{count}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {FYs.map((fy) => {
        const fyData = data.filter((o) => o.F_YEAR === fy);

        const filteredData = fyData.filter(
          (o) => !filters.trainNo || o.trainNo === filters.trainNo,
          // &&
          //   (!filters.detention_grp ||
          //     o.detention_grp === filters.detention_grp) &&
          //   (!filters.group_code || o.group_code === filters.group_code) &&
          //   (!filters.sub_group_code ||
          //     o.sub_group_code === filters.sub_group_code)
        );

        const trainMap = getCountMap(fyData, "trainNo");
        const detentionMap = getCountMap(filteredData, "detention_grp");
        const groupMap = getCountMap(filteredData, "group_code");

        const subgroupcodeMap = getCountMap(filteredData, "sub_group_code");
        const sectionMap = getCountMap(filteredData, "section");

        return (
          <div key={fy} className="mb-5">
            <div className="d-flex justify-content-center">
              <h6 className="text-center fw-bold mb-3 rounded-pill border border-dark w-25 p-2">
                Financial Year: {fy}
              </h6>{" "}
              {activeRow && (
                <h6 className="text-center fw-bold mb-3 rounded-pill border border-dark w-25 p-2">
                  Train No.: {activeRow}
                </h6>
              )}
            </div>{" "}
            <button
              className="btn btn-danger btn-sm mb-2"
              onClick={() =>
                setFilters({
                  F_YEAR: null,
                  trainNo: null,
                  section: null,
                  detention_grp: null,
                  group_code: null,
                  sub_group_code: null,
                })
              }
            >
              <RiResetLeftFill />
            </button>
            <div className="row">
              <TwoRowTable
                title="Train-wise Count"
                label="Train No"
                dataMap={trainMap}
                type="trainNo"
                F_YEAR={fy}
              />

              <TwoRowTable
                title="Detention Group-wise Count"
                label="Detention"
                dataMap={detentionMap}
                type="detention_grp"
                F_YEAR={fy}
              />

              <TwoRowTable
                title="Group-wise Count"
                label="Group"
                dataMap={groupMap}
                type="group_code"
                F_YEAR={fy}
              />

              <TwoRowTable
                title="Sub Group-wise Count"
                label="Sub Group"
                dataMap={subgroupcodeMap}
                type="sub_group_code"
                F_YEAR={fy}
              />
              <TwoRowTable
                title="Section-wise Count"
                label="Section"
                dataMap={sectionMap}
                type="section"
                F_YEAR={fy}
              />
            </div>
          </div>
        );
      })}

      <div
        className="row
      "
      >
        {filteredData && (
          <div>
            <div className="  bg-dark text-white pe-2 ps-2">
              {" "}
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center ">
                  <h4>Failure Remarks for - </h4>
                  <div className="d-flex" style={{ color: "#d0cdcdff" }}>
                    {Object.entries(filters).map(([key, value], i) => {
                      return i === 0 ? (
                        <h6 key={i}>{value}</h6>
                      ) : (
                        !value || (
                          <h6 key={i}>
                            <PiGreaterThan />
                            {value}
                          </h6>
                        )
                      );
                    })}
                  </div>
                </div>
                <div>
                  {" "}
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() =>
                      setFilters({
                        F_YEAR: null,
                        trainNo: null,
                      })
                    }
                  >
                    <RiResetLeftFill />
                  </button>
                </div>
              </div>
            </div>
            <DynamicTable
              data={filteredData}
              headers={remarkTableHeader}
              rowsPerPage={15}
              fontSize={"12px"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default LTTrainWiseSummary;
